import { render } from "./SetBirth.vue?vue&type=template&id=9991a01a&scoped=true"
import script from "./SetBirth.vue?vue&type=script&lang=js"
export * from "./SetBirth.vue?vue&type=script&lang=js"

import "./SetBirth.vue?vue&type=style&index=0&id=9991a01a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9991a01a"]])

export default __exports__